import { render, staticRenderFns } from "./CreateProjectForm.vue?vue&type=template&id=4a3a50b8&"
import script from "./CreateProjectForm.vue?vue&type=script&lang=ts&"
export * from "./CreateProjectForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports